<template>

    <div class="mbw-form-success">
        <div>
            <svg width="39" height="29" viewBox="0 0 39 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.41431 13.4142L13.4143 25.4142L37.4143 1.41422" stroke="#7CAB76" stroke-width="4" />
            </svg>

        </div>
        <div class="mbw-form-success-heading">Gotowe!</div>
        <div class="mbw-form-success-text">Dziękujemy za rejestrację. Otrzymasz jej potwierdzenie na podany wcześniej
            adres e-mail.</div>
    </div>
</template>